export const ShowByCondition: React.FC<React.PropsWithChildren<{ condition: boolean }>> = ({
	condition,
	children,
}) => (condition ? <>{children}</> : null);
